/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};var Locale;
(function (Locale) {
    Locale["Czech"] = "cs-CZ";
    Locale["German"] = "de-DE";
    Locale["EnglishUnitedStates"] = "en-US";
    Locale["EnglishGreatBritain"] = "en-GB";
    Locale["SpanishSpain"] = "es-ES";
    Locale["FrenchFrance"] = "fr-FR";
    Locale["Italian"] = "it-IT";
    Locale["Japanese"] = "ja-JP";
    Locale["Polish"] = "pl-PL";
    Locale["PortugueseBrazil"] = "pt-PT";
    Locale["ChineseChina"] = "zh-CN";
})(Locale || (Locale = {}));function getWindow() {
    try {
        return window.window;
    }
    catch (_err) {
        throw new Error('Expected `window` to be defined. For server-side applications, use a custom `AmazonJobsStore` instance.');
    }
}function defaultGetCookies() {
    var w = getWindow();
    return w.document.cookie;
}function defaultGetUrl() {
    var w = getWindow();
    return new URL(w.location.href);
}var BASE = 10;
var CONTROL_GROUP$1 = 0;
var mapValueToTreatmentGroup = function (value) {
    if (value === 'C') {
        return CONTROL_GROUP$1;
    }
    var prefixLength = 'T'.length;
    var treatmentGroupStr = value.substring(prefixLength);
    var treatmentGroup = parseInt(treatmentGroupStr, BASE);
    if (!Number.isNaN(treatmentGroup)) {
        return treatmentGroup;
    }
    return CONTROL_GROUP$1;
};
var reduceEntriesToMap = function (map, _a) {
    var _b = __read(_a, 2), key = _b[0], value = _b[1];
    var treatmentGroup = mapValueToTreatmentGroup(value);
    return new Map(__spreadArray(__spreadArray([], __read(map.entries()), false), [[key, treatmentGroup]], false));
};
function getWeblabs() {
    var monsWeblabTreatment = window.document.querySelector('meta[name="a2z:mons_weblab_treatment"]');
    if (monsWeblabTreatment === null) {
        return new Map();
    }
    var content = monsWeblabTreatment.getAttribute('content');
    if (content === null) {
        return new Map();
    }
    var entries = new URLSearchParams(content).entries();
    return __spreadArray([], __read(entries), false).reduce(reduceEntriesToMap, new Map());
}var DOMAIN_LENGTH = -2;
var SECONDS_PER_YEAR = 31536000;
function defaultSetCookie(name, value) {
    var _a = getWindow(), document = _a.document, location = _a.location;
    var hostname = location.hostname;
    var domain = hostname.split('.').splice(DOMAIN_LENGTH).join('.');
    document.cookie = [
        "".concat(name, "=").concat(value),
        "domain=".concat(domain),
        "max-age=".concat(SECONDS_PER_YEAR),
        'path=/',
    ].join('; ');
}function defaultSetUrl(url) {
    var w = getWindow();
    w.location.assign(url);
}var LegacyLocale;
(function (LegacyLocale) {
    LegacyLocale["Chinese"] = "zh";
    LegacyLocale["Czech"] = "cs";
    LegacyLocale["English"] = "en";
    LegacyLocale["EnglishGreatBritain"] = "en-gb";
    LegacyLocale["French"] = "fr";
    LegacyLocale["German"] = "de";
    LegacyLocale["Italian"] = "it";
    LegacyLocale["Japanese"] = "jp";
    LegacyLocale["Polish"] = "pl";
    LegacyLocale["Portuguese"] = "pt";
    LegacyLocale["Spanish"] = "es";
})(LegacyLocale || (LegacyLocale = {}));var LEGACY_LOCALES = new Set(Object.values(LegacyLocale));
function isLegacyLocale(value) {
    return LEGACY_LOCALES.has(value);
}var LOCALES = new Set(Object.values(Locale));
function isLocale(value) {
    return LOCALES.has(value);
}function mapCookiesToRecord(cookiesString) {
    var e_1, _a;
    var cookieStrings = cookiesString.split(/;\s*/);
    var cookiesRecord = {};
    try {
        for (var cookieStrings_1 = __values(cookieStrings), cookieStrings_1_1 = cookieStrings_1.next(); !cookieStrings_1_1.done; cookieStrings_1_1 = cookieStrings_1.next()) {
            var cookieString = cookieStrings_1_1.value;
            var _b = __read(cookieString.split('=')), name_1 = _b[0], values = _b.slice(1);
            var value = values.join('=');
            cookiesRecord[name_1] = value;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (cookieStrings_1_1 && !cookieStrings_1_1.done && (_a = cookieStrings_1.return)) _a.call(cookieStrings_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return cookiesRecord;
}function mapLocaleToLegacyLocale(locale) {
    switch (locale) {
        case Locale.ChineseChina:
            return LegacyLocale.Chinese;
        case Locale.Czech:
            return LegacyLocale.Czech;
        case Locale.EnglishUnitedStates:
            return LegacyLocale.English;
        case Locale.EnglishGreatBritain:
            return LegacyLocale.EnglishGreatBritain;
        case Locale.FrenchFrance:
            return LegacyLocale.French;
        case Locale.German:
            return LegacyLocale.German;
        case Locale.Italian:
            return LegacyLocale.Italian;
        case Locale.Japanese:
            return LegacyLocale.Japanese;
        case Locale.Polish:
            return LegacyLocale.Polish;
        case Locale.PortugueseBrazil:
            return LegacyLocale.Portuguese;
        case Locale.SpanishSpain:
            return LegacyLocale.Spanish;
    }
}function mapObjectToEntries(obj) {
    return Object.entries(obj);
}var HOMEPAGE_SERVICE = '';
var PATHNAME_PREFIX_LENGTH$2 = '/'.length;
var split = function (str, separator) {
    return str.split(separator);
};
function mapPathnameToService(pathname) {
    var _a = __read(split(pathname.substring(PATHNAME_PREFIX_LENGTH$2), '/'), 2), locale = _a[0], service = _a[1];
    if (locale === 'content') {
        return 'content';
    }
    if (isLegacyLocale(locale) || isLocale(locale)) {
        return service !== null && service !== void 0 ? service : HOMEPAGE_SERVICE;
    }
    return locale;
}function isRecord(value) {
    return typeof value === 'object' && value !== null;
}function isPartialCookiePreferences(value) {
    return (isRecord(value) &&
        (!('advertising' in value) || typeof value.advertising === 'boolean') &&
        (!('analytics' in value) || typeof value.analytics === 'boolean') &&
        (!('version' in value) || typeof value.version === 'number'));
}function validatePartialCookiePreferences(value) {
    if (isPartialCookiePreferences(value)) {
        return value;
    }
    throw new Error("Expected partial cookie preferences, but received: ".concat(typeof value, " ").concat(JSON.stringify(value)));
}var CONTROL_GROUP = 0;
var CURRENT_COOKIE_PREFERENCES_VERSION = 2;
var DEFAULT_PREFERRED_LOCALE = Locale.EnglishUnitedStates;
var EMPTY_SET = new Set();
var PATHNAME_PREFIX_LENGTH$1 = '/'.length;
var DEFAULT_ACCEPTED_LOCALES = new Set([
    Locale.EnglishUnitedStates,
]);
var INITIAL_LISTENERS = {
    acceptedLocales: EMPTY_SET,
    advertisingCookiePreference: EMPTY_SET,
    advertisingId: EMPTY_SET,
    analyticsCookiePreference: EMPTY_SET,
    analyticsId: EMPTY_SET,
    cookiePreferencesVersion: EMPTY_SET,
    locations: EMPTY_SET,
    preferredLocale: EMPTY_SET,
    requireTrackingConsent: EMPTY_SET,
    userId: EMPTY_SET,
    userType: EMPTY_SET,
};
var LEGACY_LOCALE_SERVICES = new Set([
    '',
    'benefits',
    'business_categories',
    'content',
    'cookies',
    'disability',
    'diversity',
    'eu_background_checks',
    'faqs',
    'impressum',
    'job_categories',
    'jobs',
    'landing_pages',
    'locations',
    'military',
    'principles',
    'privacy_page',
    'search-jobcategory',
    'search-teamcategory',
    'team-category',
]);
var AmazonJobsStore = (function () {
    function AmazonJobsStore(_a) {
        var _b = _a.getCookies, getCookies = _b === void 0 ? defaultGetCookies : _b, _c = _a.getUrl, getUrl = _c === void 0 ? defaultGetUrl : _c, _d = _a.getWeblabs, getWeblabs$1 = _d === void 0 ? getWeblabs : _d, _e = _a.setCookie, setCookie = _e === void 0 ? defaultSetCookie : _e, _f = _a.setUrl, setUrl = _f === void 0 ? defaultSetUrl : _f;
        var _this = this;
        this.onAcceptedLocalesChange = this.createSubscription('acceptedLocales');
        this.onAdvertisingIdChange = this.createSubscription('advertisingId');
        this.onAnalyticsIdChange = this.createSubscription('analyticsId');
        this.onLocationsChange = this.createSubscription('locations');
        this.onPreferredLocaleChange = this.createSubscription('preferredLocale');
        this.onUserIdChange = this.createSubscription('userId');
        this.onUserTypeChange = this.createSubscription('userType');
        this.removeAnalyticsIdListener = this.createUnsubscription('analyticsId');
        this.removeLocationsListener = this.createUnsubscription('locations');
        this.removeUserIdListener = this.createUnsubscription('userId');
        this.removeUserTypeListener = this.createUnsubscription('userType');
        this.onAdvertisingCookiePreferenceChange = this.createSubscription('advertisingCookiePreference');
        this.onAnalyticsCookiePreferenceChange = this.createSubscription('analyticsCookiePreference');
        this.onCookiePreferencesVersionChange = this.createSubscription('cookiePreferencesVersion');
        this.onRequireTrackingConsentChange = this.createSubscription('requireTrackingConsent');
        this.removeAdvertisingCookiePreferenceListener = this.createUnsubscription('advertisingCookiePreference');
        this.removeAcceptedLocalesListener = this.createUnsubscription('acceptedLocales');
        this.removeAdvertisingIdListener = this.createUnsubscription('advertisingId');
        this.removeAnalyticsCookiePreferenceListener = this.createUnsubscription('analyticsCookiePreference');
        this.removeCookiePreferencesVersionListener = this.createUnsubscription('cookiePreferencesVersion');
        this.removePreferredLocaleListener = this.createUnsubscription('preferredLocale');
        this.removeRequireTrackingConsentListener = this.createUnsubscription('requireTrackingConsent');
        this._acceptedLocales = DEFAULT_ACCEPTED_LOCALES;
        this._listeners = INITIAL_LISTENERS;
        this._requireTrackingConsent = true;
        this.getAcceptedLocales = function () {
            return _this._acceptedLocales;
        };
        this.getAdvertisingCookiePreference = function () {
            return _this.cookiePreferences.advertising;
        };
        this.getAdvertisingId = function () {
            var _a;
            if (!_this.getAdvertisingCookiePreference()) {
                return null;
            }
            return (_a = _this.getCookie('advertising_id')) !== null && _a !== void 0 ? _a : null;
        };
        this.getAnalyticsCookiePreference = function () {
            return _this.cookiePreferences.analytics;
        };
        this.getAnalyticsId = function () {
            var _a;
            if (!_this.getAnalyticsCookiePreference()) {
                return null;
            }
            return (_a = _this.getCookie('analytics_id')) !== null && _a !== void 0 ? _a : null;
        };
        this.getCookiePreferencesVersion = function () {
            return _this.cookiePreferences.version;
        };
        this.getLocations = function () {
            return _this._locations;
        };
        this.getPreferredLocale = function () {
            var preferredLocale = _this.getCookie('preferred_locale');
            if (isLocale(preferredLocale)) {
                return preferredLocale;
            }
            return DEFAULT_PREFERRED_LOCALE;
        };
        this.getTrackingConsentRequirement = function () {
            return _this._requireTrackingConsent;
        };
        this.getUserId = function () {
            return _this._userId;
        };
        this.getUserType = function () {
            return _this._userType;
        };
        this.getWeblab = function (name) {
            var weblabs = _this._getWeblabs();
            var treatmentGroup = weblabs.get(name);
            return treatmentGroup !== null && treatmentGroup !== void 0 ? treatmentGroup : CONTROL_GROUP;
        };
        this.isLegacyLocaleService = function (service) {
            if (service === 'search') {
                return _this.getWeblab('AMAZON_JOBS_787563') === CONTROL_GROUP;
            }
            return LEGACY_LOCALE_SERVICES.has(service);
        };
        this.setAcceptedLocales = function (locales) {
            return _this.emitChange(function () {
                _this._acceptedLocales = locales;
            });
        };
        this.setAdvertisingCookiePreference = function (preference) {
            return _this.setCookiePreferences({
                advertising: preference,
            });
        };
        this.setAdvertisingId = function (id) {
            return _this.setCookie('advertising_id', id);
        };
        this.setAnalyticsCookiePreference = function (preference) {
            return _this.setCookiePreferences({
                analytics: preference,
            });
        };
        this.setAnalyticsId = function (id) {
            return _this.setCookie('analytics_id', id);
        };
        this.setCookie = function (name, value) {
            return _this.emitChange(function () {
                _this._setCookie(name, value);
            });
        };
        this.setCookiePreferences = function (preferences) {
            var newCookiePreferences = __assign(__assign(__assign({}, _this.cookiePreferences), preferences), { version: CURRENT_COOKIE_PREFERENCES_VERSION });
            return _this.setCookie('cookie_preferences', encodeURIComponent(JSON.stringify(newCookiePreferences)));
        };
        this.setCookiePreferencesVersion = function (version) {
            return _this.setCookiePreferences({
                version: version,
            });
        };
        this.setLocations = function (locations) {
            return _this.emitChange(function () {
                _this._locations = locations;
            });
        };
        this.setPathnameLocale = function (pathname, locale) {
            var service = mapPathnameToService(pathname);
            var newLocale = _this.getServiceLocale(service, locale);
            var _a = __read(pathname
                .substring(PATHNAME_PREFIX_LENGTH$1)
                .split('/')), first = _a[0], rest = _a.slice(1);
            if (first === 'content') {
                var _b = __read(rest), contentLocale = _b[0], cmsRest = _b.slice(1);
                if (isLegacyLocale(contentLocale) || isLocale(contentLocale)) {
                    return __spreadArray(['', 'content', newLocale], __read(cmsRest), false).join('/');
                }
                return __spreadArray(['', 'content', newLocale], __read(rest), false).join('/');
            }
            if (isLegacyLocale(first) || isLocale(first)) {
                return __spreadArray(['', newLocale], __read(rest), false).join('/');
            }
            return __spreadArray(['', newLocale, first], __read(rest), false).join('/');
        };
        this.setPreferredLocale = function (locale) {
            var newState = _this.setCookie('preferred_locale', locale);
            _this.setPreferredLocalePathname(locale);
            return newState;
        };
        this.setTrackingConsentRequirement = function (required) {
            return _this.emitChange(function () {
                _this._requireTrackingConsent = required;
            });
        };
        this.setUserId = function (userId) {
            return _this.emitChange(function () {
                _this._userId = userId;
            });
        };
        this.setUserType = function (userType) {
            return _this.emitChange(function () {
                _this._userType = userType;
            });
        };
        this._getCookies = getCookies;
        this._getUrl = getUrl;
        this._getWeblabs = getWeblabs$1;
        this._setCookie = setCookie;
        this._setUrl = setUrl;
    }
    Object.defineProperty(AmazonJobsStore.prototype, "cookiePreferences", {
        get: function () {
            var value = this.getCookie('cookie_preferences');
            return this.mapCookiePreferencesValueToRecord(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmazonJobsStore.prototype, "cookies", {
        get: function () {
            var cookies = this._getCookies();
            return mapCookiesToRecord(cookies);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmazonJobsStore.prototype, "defaultCookiePreferences", {
        get: function () {
            return {
                advertising: !this._requireTrackingConsent,
                analytics: !this._requireTrackingConsent,
                version: 0,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmazonJobsStore.prototype, "state", {
        get: function () {
            return {
                acceptedLocales: this.getAcceptedLocales(),
                advertisingCookiePreference: this.getAdvertisingCookiePreference(),
                advertisingId: this.getAdvertisingId(),
                analyticsCookiePreference: this.getAnalyticsCookiePreference(),
                analyticsId: this.getAnalyticsId(),
                cookiePreferencesVersion: this.getCookiePreferencesVersion(),
                locations: this.getLocations(),
                preferredLocale: this.getPreferredLocale(),
                requireTrackingConsent: this.getTrackingConsentRequirement(),
                userId: this.getUserId(),
                userType: this.getUserType(),
            };
        },
        enumerable: false,
        configurable: true
    });
    AmazonJobsStore.prototype.addListener = function (key, callback) {
        var _a;
        this._listeners = __assign(__assign({}, this._listeners), (_a = {}, _a[key] = new Set(__spreadArray(__spreadArray([], __read(this._listeners[key]), false), [callback], false)), _a));
    };
    AmazonJobsStore.prototype.createSubscription = function (key) {
        var _this = this;
        return function (callback) {
            _this.addListener(key, callback);
            return function () {
                _this.removeListener(key, callback);
            };
        };
    };
    AmazonJobsStore.prototype.createUnsubscription = function (key) {
        var _this = this;
        return function (callback) {
            _this.removeListener(key, callback);
        };
    };
    AmazonJobsStore.prototype.emit = function (key, value) {
        var e_1, _a;
        try {
            for (var _b = __values(this._listeners[key]), _c = _b.next(); !_c.done; _c = _b.next()) {
                var handleChange = _c.value;
                handleChange(value);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    AmazonJobsStore.prototype.emitChange = function (change) {
        var oldState = this.state;
        change();
        this.emitDifference(oldState);
        return this.state;
    };
    AmazonJobsStore.prototype.emitDifference = function (oldState) {
        var e_2, _a;
        var newState = this.state;
        var entries = mapObjectToEntries(newState);
        try {
            for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                var _b = __read(entries_1_1.value, 2), key = _b[0], newValue = _b[1];
                var oldValue = oldState[key];
                if (oldValue === newValue) {
                    continue;
                }
                this.emit(key, newValue);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    AmazonJobsStore.prototype.getCookie = function (name) {
        return this.cookies[name];
    };
    AmazonJobsStore.prototype.getServiceLocale = function (service, locale) {
        if (this.isLegacyLocaleService(service)) {
            return mapLocaleToLegacyLocale(locale);
        }
        return locale;
    };
    AmazonJobsStore.prototype.mapCookiePreferencesValueToRecord = function (value) {
        if (typeof value === 'undefined') {
            return this.defaultCookiePreferences;
        }
        try {
            var decodedValue = decodeURIComponent(value);
            var json = JSON.parse(decodedValue);
            return __assign(__assign({}, this.defaultCookiePreferences), validatePartialCookiePreferences(json));
        }
        catch (err) {
            return this.defaultCookiePreferences;
        }
    };
    AmazonJobsStore.prototype.removeListener = function (key, callback) {
        var _a;
        var oldCallbacks = this._listeners[key];
        var newCallbacks = new Set(__spreadArray([], __read(oldCallbacks), false));
        newCallbacks.delete(callback);
        this._listeners = __assign(__assign({}, this._listeners), (_a = {}, _a[key] = newCallbacks, _a));
    };
    AmazonJobsStore.prototype.setPreferredLocalePathname = function (locale) {
        var previousUrl = this._getUrl();
        var nextUrl = new URL(previousUrl);
        nextUrl.pathname = this.setPathnameLocale(previousUrl.pathname, locale);
        this._setUrl(nextUrl);
    };
    return AmazonJobsStore;
}());var DEFAULT_STORE = new AmazonJobsStore({});var UserType;
(function (UserType) {
    UserType["External"] = "EXTERNAL";
    UserType["Internal"] = "INTERNAL";
})(UserType || (UserType = {}));var GlobalVariable;
(function (GlobalVariable) {
    GlobalVariable["AwsRum"] = "awsRum";
})(GlobalVariable || (GlobalVariable = {}));function getGlobalVariable(key) {
    if (!('__AMAZON_JOBS__' in window)) {
        return;
    }
    if (typeof window.__AMAZON_JOBS__ !== 'object' ||
        window.__AMAZON_JOBS__ === null ||
        !(key in window.__AMAZON_JOBS__)) {
        return;
    }
    return window.__AMAZON_JOBS__[key];
}function getAwsRum() {
    return getGlobalVariable(GlobalVariable.AwsRum);
}var USER_TYPES = new Set(Object.values(UserType));
function isUserType(value) {
    return USER_TYPES.has(value);
}function mapLegacyLocaleToLocale(locale) {
    switch (locale) {
        case LegacyLocale.Chinese:
            return Locale.ChineseChina;
        case LegacyLocale.Czech:
            return Locale.Czech;
        case LegacyLocale.English:
            return Locale.EnglishUnitedStates;
        case LegacyLocale.EnglishGreatBritain:
            return Locale.EnglishGreatBritain;
        case LegacyLocale.French:
            return Locale.FrenchFrance;
        case LegacyLocale.German:
            return Locale.German;
        case LegacyLocale.Italian:
            return Locale.Italian;
        case LegacyLocale.Japanese:
            return Locale.Japanese;
        case LegacyLocale.Polish:
            return Locale.Polish;
        case LegacyLocale.Portuguese:
            return Locale.PortugueseBrazil;
        case LegacyLocale.Spanish:
            return Locale.SpanishSpain;
    }
}function mapToLocale(value) {
    if (isLocale(value)) {
        return value;
    }
    if (isLegacyLocale(value)) {
        return mapLegacyLocaleToLocale(value);
    }
    return Locale.EnglishUnitedStates;
}var PATHNAME_PREFIX_LENGTH = '/'.length;
function mapPathnameToLocale(pathname) {
    var _a = __read(pathname.substring(PATHNAME_PREFIX_LENGTH).split('/'), 2), first = _a[0], second = _a[1];
    if (first === 'content') {
        return mapToLocale(second);
    }
    return mapToLocale(first);
}var FIRST = 0;
var QUEUE = [];
function recordError(err) {
    var e_1, _a;
    var rum = getAwsRum();
    if (typeof rum !== 'object' ||
        rum === null ||
        !('recordError' in rum) ||
        typeof rum.recordError !== 'function') {
        QUEUE.push(err);
        return;
    }
    try {
        for (var _b = __values(QUEUE.splice(FIRST, QUEUE.length)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var error = _c.value;
            rum.recordError(error);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    rum.recordError(err);
}function recordEvent(name, data) {
    var rum = getAwsRum();
    if (typeof rum !== 'object' ||
        rum === null ||
        !('recordEvent' in rum) ||
        typeof rum.recordEvent !== 'function') {
        return;
    }
    rum.recordEvent(name, data);
}function setGlobalVariable(key, value) {
    var _a, _b;
    var w = window;
    if ('__AMAZON_JOBS__' in w) {
        w.__AMAZON_JOBS__ = __assign(__assign({}, w.__AMAZON_JOBS__), (_a = {}, _a[key] = value, _a));
        return;
    }
    w.__AMAZON_JOBS__ = (_b = {},
        _b[key] = value,
        _b);
}function setAwsRum(value) {
    setGlobalVariable(GlobalVariable.AwsRum, value);
}var getAcceptedLocales = DEFAULT_STORE.getAcceptedLocales, getAdvertisingCookiePreference = DEFAULT_STORE.getAdvertisingCookiePreference, getAdvertisingId = DEFAULT_STORE.getAdvertisingId, getAnalyticsCookiePreference = DEFAULT_STORE.getAnalyticsCookiePreference, getAnalyticsId = DEFAULT_STORE.getAnalyticsId, getCookiePreferencesVersion = DEFAULT_STORE.getCookiePreferencesVersion, getLocations = DEFAULT_STORE.getLocations, getPreferredLocale = DEFAULT_STORE.getPreferredLocale, getTrackingConsentRequirement = DEFAULT_STORE.getTrackingConsentRequirement, getUserId = DEFAULT_STORE.getUserId, getUserType = DEFAULT_STORE.getUserType, getWeblab = DEFAULT_STORE.getWeblab, isLegacyLocaleService = DEFAULT_STORE.isLegacyLocaleService, onAcceptedLocalesChange = DEFAULT_STORE.onAcceptedLocalesChange, onAdvertisingCookiePreferenceChange = DEFAULT_STORE.onAdvertisingCookiePreferenceChange, onAdvertisingIdChange = DEFAULT_STORE.onAdvertisingIdChange, onAnalyticsCookiePreferenceChange = DEFAULT_STORE.onAnalyticsCookiePreferenceChange, onAnalyticsIdChange = DEFAULT_STORE.onAnalyticsIdChange, onCookiePreferencesVersionChange = DEFAULT_STORE.onCookiePreferencesVersionChange, onLocationsChange = DEFAULT_STORE.onLocationsChange, onPreferredLocaleChange = DEFAULT_STORE.onPreferredLocaleChange, onRequireTrackingConsentChange = DEFAULT_STORE.onRequireTrackingConsentChange, onUserIdChange = DEFAULT_STORE.onUserIdChange, onUserTypeChange = DEFAULT_STORE.onUserTypeChange, removeAcceptedLocalesListener = DEFAULT_STORE.removeAcceptedLocalesListener, removeAdvertisingCookiePreferenceListener = DEFAULT_STORE.removeAdvertisingCookiePreferenceListener, removeAdvertisingIdListener = DEFAULT_STORE.removeAdvertisingIdListener, removeAnalyticsCookiePreferenceListener = DEFAULT_STORE.removeAnalyticsCookiePreferenceListener, removeAnalyticsIdListener = DEFAULT_STORE.removeAnalyticsIdListener, removeCookiePreferencesVersionListener = DEFAULT_STORE.removeCookiePreferencesVersionListener, removeLocationsListener = DEFAULT_STORE.removeLocationsListener, removePreferredLocaleListener = DEFAULT_STORE.removePreferredLocaleListener, removeRequireTrackingConsentListener = DEFAULT_STORE.removeRequireTrackingConsentListener, removeUserIdListener = DEFAULT_STORE.removeUserIdListener, removeUserTypeListener = DEFAULT_STORE.removeUserTypeListener, setAcceptedLocales = DEFAULT_STORE.setAcceptedLocales, setAdvertisingCookiePreference = DEFAULT_STORE.setAdvertisingCookiePreference, setAdvertisingId = DEFAULT_STORE.setAdvertisingId, setAnalyticsCookiePreference = DEFAULT_STORE.setAnalyticsCookiePreference, setAnalyticsId = DEFAULT_STORE.setAnalyticsId, setCookie = DEFAULT_STORE.setCookie, setCookiePreferences = DEFAULT_STORE.setCookiePreferences, setCookiePreferencesVersion = DEFAULT_STORE.setCookiePreferencesVersion, setLocations = DEFAULT_STORE.setLocations, setPathnameLocale = DEFAULT_STORE.setPathnameLocale, setPreferredLocale = DEFAULT_STORE.setPreferredLocale, setTrackingConsentRequirement = DEFAULT_STORE.setTrackingConsentRequirement, setUserId = DEFAULT_STORE.setUserId, setUserType = DEFAULT_STORE.setUserType;export{AmazonJobsStore,CURRENT_COOKIE_PREFERENCES_VERSION,Locale,UserType,DEFAULT_STORE as default,getAcceptedLocales,getAdvertisingCookiePreference,getAdvertisingId,getAnalyticsCookiePreference,getAnalyticsId,getAwsRum,getCookiePreferencesVersion,getLocations,getPreferredLocale,getTrackingConsentRequirement,getUserId,getUserType,getWeblab,isLegacyLocaleService,isLocale,isUserType,mapLocaleToLegacyLocale,mapPathnameToLocale,mapPathnameToService,onAcceptedLocalesChange,onAdvertisingCookiePreferenceChange,onAdvertisingIdChange,onAnalyticsCookiePreferenceChange,onAnalyticsIdChange,onCookiePreferencesVersionChange,onLocationsChange,onPreferredLocaleChange,onRequireTrackingConsentChange,onUserIdChange,onUserTypeChange,recordError,recordEvent,removeAcceptedLocalesListener,removeAdvertisingCookiePreferenceListener,removeAdvertisingIdListener,removeAnalyticsCookiePreferenceListener,removeAnalyticsIdListener,removeCookiePreferencesVersionListener,removeLocationsListener,removePreferredLocaleListener,removeRequireTrackingConsentListener,removeUserIdListener,removeUserTypeListener,setAcceptedLocales,setAdvertisingCookiePreference,setAdvertisingId,setAnalyticsCookiePreference,setAnalyticsId,setAwsRum,setCookie,setCookiePreferences,setCookiePreferencesVersion,setLocations,setPathnameLocale,setPreferredLocale,setTrackingConsentRequirement,setUserId,setUserType};//# sourceMappingURL=index.js.map
